export const getPositionStyle = (
  clientX: number,
  clientY: number,
  isDeltaTooltip?: boolean,
) => {
  let offsetLeft = -5;
  let offsetTop = -5;
  const cardHeight = isDeltaTooltip ? 253 : 237;
  const left = clientX;
  const top = clientY;

  // if data point is at right most side of screen
  if (left + (isDeltaTooltip ? 318 : 274) > window.innerWidth) {
    offsetLeft -= isDeltaTooltip ? 313 : 269;
  }
  // if data point is at bottom most side of screen
  if (top + cardHeight + offsetTop > window.innerHeight) {
    offsetTop = window.innerHeight - (top + offsetTop + cardHeight);
  }

  return { top: `${top + offsetTop}px`, left: `${left + offsetLeft}px` };
};
